// import http from "@/config/httpSend";

const commonStore = {
  namespaced: true,
  state: {
    menu: [],
  },
  getters: {
    GE_MENU_DATA: (state) => {
      return state.menu;
    },
  },
  mutations: {
    MU_MENU_DATA: (state, payload) => {
      // console.log('MU_SET_DB', payload)
      state.menu = payload.data.data_list.items;
    },
  },
  actions: {
    //
  },
};

export default commonStore;
